// extracted by mini-css-extract-plugin
module.exports = {"tagChip":"ChipBar_tagChip__aXLmc","feedRowBottom":"ChipBar_feedRowBottom__lZprT","tagBar":"ChipBar_tagBar__5T1PE","feedRowBottomLeft":"ChipBar_feedRowBottomLeft__EglU2"};